import {Draggable, Droppable} from "@hello-pangea/dnd";
import React, {useEffect, useState} from "react";
import Button from "../../components/elements/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import {
    faChevronLeft, faLanguage,
    faReorder,
    faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import ButtonLink from "../elements/ButtonLink";
import ThreeDotMenu from "./ThreeDotMenu";

export default function SectionCard({
                                        s,
                                        index,
                                        expanded,
                                        toggleExpand,
                                        onEdit,
                                        onDelete,
                                        onDeleteContent,
                                        courseId
                                    }) {

    return (
        <Draggable
            draggableId={String(s.id)}
            index={index}
        >
            {(provided) => (
                <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    className="bg-white rounded-lg p-3 border shadow-sm flex flex-col"
                >
                    <div className="flex items-start justify-between">
                        <div className="flex items-center gap-3">
                            <div className="flex items-center gap-2">
                                <div
                                    {...provided.dragHandleProps}
                                    className="cursor-grab p-1 rounded hover:bg-gray-100"
                                    title="درگ برای تغییر ترتیب"
                                >
                                    <FontAwesomeIcon icon={faReorder} size={"xl"}/>
                                </div>
                            </div>

                            <div>
                                <h3 className="font-semibold mx-5 text-base">{s.id || 'بدون id'}</h3>
                            </div>
                            <div>
                                <Button
                                    onClick={() => toggleExpand(s.id)}>
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        size={"lg"}
                                        className={expanded[s.id] ? "-rotate-90 transition-all" : "transition-all"}
                                    />
                                </Button>
                            </div>
                        </div>

                        <div className="flex items-center gap-5">
                            <ThreeDotMenu
                                onEdit={() => onEdit(s)}
                                onDelete={() => onDelete(s)}
                            />
                        </div>
                    </div>

                    {s.description ? <p className="mt-2 text-sm text-gray-700">{s.description}</p> : null}

                    {expanded[s.id] && (
                        <div className="m-5 bg-gray-200">
                            <Droppable droppableId={`contents-${s.id}`} type={`CONTENT-${s.id}`}>
                                {(providedCont) => (
                                    <div ref={providedCont.innerRef} {...providedCont.droppableProps}
                                         className="space-y-2">
                                        {(s.contents || []).filter(c => !c._deleted).map((c, idx) => (
                                            <Draggable key={String(c.id)} draggableId={String(c.id)} index={idx}>
                                                {(prov) => (
                                                    <div
                                                        ref={prov.innerRef}
                                                        {...prov.draggableProps}
                                                        {...prov.dragHandleProps}
                                                        className="flex items-center justify-between p-2 border rounded bg-white"
                                                    >
                                                        <div>
                                                            <div className="text-sm font-medium">
                                                                {c.id || 'بدون عنوان'}
                                                            </div>
                                                            <div className="text-xs text-gray-500">
                                                                position: {c.position} • type: {c.type}
                                                            </div>
                                                        </div>
                                                        <div className="flex items-center gap-2">
                                                            <Button onClick={() => onDeleteContent(s.id, c.id)}>
                                                                <FontAwesomeIcon icon={faTrashCan} size={"lg"}/>
                                                            </Button>
                                                            <ButtonLink
                                                                to={`/admin/course/${courseId}/content/${c.id}`}
                                                            >
                                                                <FontAwesomeIcon icon={faChevronLeft} size={"lg"}/>
                                                            </ButtonLink>
                                                        </div>
                                                    </div>
                                                )}
                                            </Draggable>
                                        ))}
                                        {providedCont.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </div>
                    )}
                </div>
            )}
        </Draggable>
    );
}
